import { ApiClient } from 'app/service/api-service'
import { SchoolEndPoint } from './constant'
import {
  IParamsGetSchool,
  IPayloadCreateSchool,
  IPayloadUpdateSchool,
} from './model'

export const requestGetSchool = (body: IParamsGetSchool) =>
  ApiClient.Post({
    url: SchoolEndPoint.GET,
    body,
  })

export const requestPostCreateSchool = (body: IPayloadCreateSchool) =>
  ApiClient.Post({
    url: SchoolEndPoint.CREATE,
    body,
  })

export const requestUpdateSchool = (body: IPayloadUpdateSchool) =>
  ApiClient.Put({
    url: SchoolEndPoint.UPDATE,
    body,
  })

export const requestDeleteSchool = (listId: number[]) =>
  ApiClient.Put({
    url: SchoolEndPoint.DELETE,
    body: { listId },
  })

// get detail unit
export const requestGetDetailSchool = (id: number) =>
  ApiClient.Get({
    url: SchoolEndPoint.DETAIL,
    params: { id },
  })
